import React from 'react'
import tw from 'tailwind-styled-components'
import {getSize} from '@components/common/base/icon'
import {
  IconTabler,
  TablerIcons
} from '@components/common/icon-tabler/icon-tabler'

interface IconProps {
  size?: 16 | 24 | 32
  icon: TablerIcons
}

const TwIconButton = tw.div<{$size: 16 | 24 | 32}>`
  ${p => getSize(p.$size)}
  select-none
`

export const IconWithoutColor = ({size, icon}: IconProps) => {
  return (
    <TwIconButton $size={size}>
      <IconTabler customSize={size} icon={icon} viewBox="0 0 24 24" />
    </TwIconButton>
  )
}
